import React, { useEffect, useState } from 'react';
import constantes, { nombreEleccion } from '../../resources/constantes.json';
import { useNomenclator } from '../../contexts/nomenclatorContext.js';
import { useSetPage } from '../../contexts/pageContext';

/**
 * Se encarga de hacer fetch de los datos necesarios y cambiar el estado de la aplicación
 * según estemos en una página de estadísticas
 */


const GetStatsData = ({ page }) => {

  const nomenclator = useNomenclator();
  const { pathname } = window.location
  const pathArray = pathname.replace('/', '').split('/')
  const codeElecFromUrl = constantes.eleccion[pathArray[1]]


  const defaultElecCode = nomenclator.ordAmbitos[0]
  const defaultElecName = nombreEleccion[defaultElecCode]

  if (!codeElecFromUrl) {
    window.location.replace(`/estadisticas/${defaultElecName}`);
  }

  const [elec, setElec] = useState(codeElecFromUrl ? codeElecFromUrl : defaultElecCode);
  const eleccion = constantes.nomAmbitos[constantes.nombreEleccion[elec]];
  const [tipoEst, setTipoEst] = useState('R');
  const [tipoEst2, setTipoEst2] = useState('C');
  const [tipoDato, setTipoDato] = useState('PA');
  const [tipoDato2, setTipoDato2] = useState('VT');

  const dataUrl = [getDataUrl(tipoDato, 'R'), getDataUrl(tipoDato2, 'C')]

  function getDataUrl(tipoDatoProp, tipoEstadisticaProp) {

    if (Array.isArray(tipoDatoProp)) {
      const urlArray = []
      tipoDatoProp.forEach(dato => {
        urlArray.push(`/json/ACT/${eleccion}/${constantes.prefijos.estadisticas}${tipoEstadisticaProp}${dato}.json`)
      })
      return urlArray

    } else {
      return `/json/ACT/${eleccion}/${constantes.prefijos.estadisticas}${tipoEstadisticaProp}${tipoDatoProp}.json`
    }
  }

  const initialUrlInfo = React.useMemo(
    () => ({
      elec,
      tipoEst,
      tipoEst2,
      tipoDato,
      tipoDato2,
      page: nombreEleccion[elec],
      setElec,
      setTipoEst,
      setTipoEst2,
      setTipoDato,
      setTipoDato2
    }),
    [elec, tipoEst, tipoEst2, tipoDato, tipoDato2]
  );

  const setPage = useSetPage();

  useEffect(() => {
    const pathArray = pathname.replace('/', '').split('/')
    const codeElecFromUrl = constantes.eleccion[pathArray[1]]
    const defaultElecCode = nomenclator.ordAmbitos[0]
    setElec((codeElecFromUrl ? codeElecFromUrl : defaultElecCode));
  }, [nomenclator.ordAmbitos, pathname]);

  useEffect(() => {
    setPage(dataUrl, initialUrlInfo);
  }, [dataUrl, initialUrlInfo, setPage]);

  return null;
};

export default GetStatsData;
